import { useElasticData, useExtraData } from "../DataContext.js";

const LevellingPanel = ({tabIndex, sel}) => {
        
    let { bookMatchRatings } = useElasticData();
        
    let { _source, isGuestUser } = useExtraData();
    const name = `tab-${tabIndex}`;

    const bookBandList = (pclinks) => {
        let bblHtml = "";

        if(pclinks){
            pclinks.filter(c => bookBands[c]).forEach((pc, i) => {
                bblHtml += `<li><span class="swatch cat${pc}" title="${bookBands[pc]}">${bookBands[pc]}</span></li>`;
            });
        }

        if (bblHtml == "") {
            return "";
        }

        return `<ul class="bookBanding">${bblHtml}</ul>`;
    };
    const bookbandsArray = _source.productcategorylinks ? _source.productcategorylinks.filter(pcl => bookBands[pcl]) : [];
    // Levelling information
    let _levelling = [];
    
    if (bookMatchRatings?.length > 0) {
        _levelling.push({
            "heading": "Oxford BookMatch<sup>&trade;</sup>",
            "rows": {
                "Level": `${bookMatchRatings.bmLowLevel} - ${bookMatchRatings.bmHighLevel}`
            }
        })
    }
    
    if (_source.book_level || _source.ar_interest_level || _source.quiz_number || _source.points) {
        let rows = {};
        
        if (_source.book_level) {
            rows["Level"] = _source.book_level;
        }

        if (_source.ar_interest_level) {
            rows["Interest"] = _source.ar_interest_level;
        }

        if (_source.quiz_number) {
            rows["Quiz Number"] = _source.quiz_number;
        }

        if (_source.points) {
            rows["Points"] = parseFloat(_source.points).toFixed(1);
        }

        _levelling.push({
            "heading" : "Renaissance AR<sup>&trade;</sup>",
            "rows" : rows
        });
    }

    if (bookbandsArray.length > 0) {
        _levelling.push({
            "heading" : "Book Band(s)",
            "rows" : {
                "" : bookBandList(_source.productcategorylinks)
            }
        });
    }

    const levellingHeadings = _levelling.map(x => x.heading);
    const levellingRows = Object.values(_levelling.map(x => x.rows));
    let levellingHtml = "";

    levellingRows.forEach((rows, i) => {
        let rowLabels = Object.keys(rows);
        let rowValues = Object.values(rows);
        let levellingRowsHtml = "";
        
        rowLabels.forEach((label, j) => {
            levellingRowsHtml += `${label ? `<div class="half column"><strong>${label}</strong></div>` : ``}<div class="half column">${rowValues[j]}</div>`;
        });

        levellingHtml += `<div class="half column"><h4>${levellingHeadings[i]}</h4><div class="columns wrap">${levellingRowsHtml}</div></div>`;

    });

    return(
        <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
            {isGuestUser && <div className="loginRequired"><a className="login">Log in</a> to view levelling information.</div>}
            {!isGuestUser && <div className="columns wrap" dangerouslySetInnerHTML={{__html: levellingHtml}} />}
        </div>
    )
}

export default LevellingPanel;